module.exports = __webpack_public_path__ + "static/ff0f3d0f7f3349b4b9a16023203dc99ad32d0048b2d185fbfd69e3eb844a36e7-191aae8d722dc03a6a8406396dfbed3e.png";